/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DuplicateDashboardRequestBody = {
  /**
   * The dashboard to copy
   */
  id: string;
};

/** @internal */
export type DuplicateDashboardRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const DuplicateDashboardRequestBody$outboundSchema: z.ZodMiniType<
  DuplicateDashboardRequestBody$Outbound,
  DuplicateDashboardRequestBody
> = z.object({
  id: z.string(),
});

export function duplicateDashboardRequestBodyToJSON(
  duplicateDashboardRequestBody: DuplicateDashboardRequestBody,
): string {
  return JSON.stringify(
    DuplicateDashboardRequestBody$outboundSchema.parse(
      duplicateDashboardRequestBody,
    ),
  );
}
